import type { StoredProjectRecord } from "./project-record";
import { copyDocument } from "./project-record";

export interface RecoveryRecord {
  projectData: StoredProjectRecord;
  savedAt: string;
}
export interface RecoveryStore {
  read(): Promise<unknown>;
  write(record: RecoveryRecord): Promise<boolean>;
}

/** A slow earlier write can never overtake a later edit, including after a failed write. */
export class RecoveryRepository {
  private queue: Promise<unknown> = Promise.resolve();
  constructor(private readonly store: RecoveryStore) {}

  async read(): Promise<unknown> {
    await this.queue;
    return this.store.read();
  }

  write(
    projectData: StoredProjectRecord,
    savedAt = new Date().toISOString(),
  ): Promise<boolean> {
    const record = copyDocument({ projectData, savedAt });
    const operation = this.queue.then(() => this.store.write(record));
    this.queue = operation.catch(() => undefined);
    return operation;
  }
}
